import type { AnatomyBinding, AnatomySize } from "./componentAnatomy";
import { anatomyTextStyle } from "./componentAnatomyText";

// Mined from .lg / .xl in TagsInput.module.scss. Text style and the 22px
// typing row live on .root / .control and do not vary.
const minHeightBinding = (minHeight: string): AnatomyBinding => ({
    partId: "background",
    property: "min-height",
    literal: minHeight,
    note: "A floor, not a height: the box grows as chips wrap.",
});

const sTextBindings = anatomyTextStyle({
    scale: "s",
    weight: "400",
    mixin: "text-s-14-regular",
});

export const tagsInputSizes: readonly AnatomySize[] = [
    {
        id: "lg",
        label: "lg · 32",
        selector: ".lg",
        bindings: [
            minHeightBinding("32px"),
            {
                partId: "background",
                property: "padding-inline",
                token: "--space-4",
            },
            {
                partId: "background",
                property: "padding-block",
                token: "--space-4",
            },
            ...sTextBindings,
        ],
    },
    {
        id: "xl",
        label: "xl · 40",
        selector: ".xl",
        bindings: [
            minHeightBinding("40px"),
            {
                partId: "background",
                property: "padding-inline",
                token: "--space-12",
            },
            {
                partId: "background",
                property: "padding-block",
                literal: "calc((40px - 2 * var(--border-width) - 28px) / 2)",
                note: "ds-deviation: centres a 28px chip row in the 40px min height.",
            },
            ...sTextBindings,
        ],
    },
];
